<template>
  <div class="rhlistDrawer">
    <Drawer
      :mask-closable="false"
      class="common-drawer common-drawer1"
      :title="title"
      v-model="showInDrawer"
      :width="dologwidth"
      @on-close="drwcloseDrawer"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
      >
        <Row :gutter="16">
          <Col span="24" id="companyName">
            <FormItem label="租户名称" prop="companyName">
              <Input
                name="companyName"
                v-model="formData.companyName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="税号" prop="dutyParagraph">
              <Input
                name="dutyParagraph"
                v-model="formData.dutyParagraph"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24 ">
            <FormItem label="租户类型" :required="true" prop="type">
              <Select
                ref="typetrue"
                :clearable="typetrue"
                id="type"
                :disabled="formData._tupedisabled"
                v-model="formData.type"
                placeholder="请选择"
              >
                <Option value="0">经销商</Option>
                <Option value="1">客户</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-if="formData.type == 1" span="24">
            <FormItem label="测试租户" :required="true">
              <Select name="testTenant" v-model="formData.testTenant">
                <Option value="0">否</Option>
                <Option value="1">是</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="24" class="timer">
            <FormItem label="本次开通时间">
              <DatePicker
                v-model="formData.openDate"
                @on-change="changeDateOpen"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择"
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="24" class="timer" v-if="formData.openDate">
            <FormItem label="本次到期时间">
              <DatePicker
                v-model="formData.expireDate"
                :options="expireDateOptions"
                @on-change="changeDateExpire"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择"
                style="width: 100%"
              ></DatePicker>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="管理员姓名" prop="administratorName">
              <Input
                name="administratorName"
                v-model="formData.administratorName"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="管理员手机号" prop="administratorMobile">
              <Input
                name="administratorMobile"
                v-model="formData.administratorMobile"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="管理员邮箱" prop="administratorEmail">
              <Input
                name="administratorEmail"
                v-model="formData.administratorEmail"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          id="hireOk"
          type="primary"
          @click="confirm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="drwcloseDrawer">取消</Button>
      </div>
    </Drawer>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import moment from "moment";
import { mapState } from "vuex";
import { isFirstCharacterNotDigit } from "@/util/common.js";
export default {
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写租户名称"));
      } else if (isFirstCharacterNotDigit(value)) {
        callback(new Error("首个字符不能为数字"));
      } else {
        callback();
      }
    };
    const validateTax = (rule, value, callback) => {
      if (
        value === "" ||
        /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
          value
        ) === false
      ) {
        callback(new Error("请填写正确的税号"));
      } else {
        callback();
      }
    };
    // const validatePhone = (rule, value, callback) => {
    //     const valueCopy = value.replace(/\s/g, "");
    //     if (valueCopy === "" || /^[0-9]*$/.test(valueCopy) === false) {
    //         callback(new Error("请填写正确的手机号"));
    //     } else {
    //         callback();
    //     }
    // };
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      // } else if (!/^1[3456789]\d{9}$/.test(value)) {
      //   callback("手机号格式不正确");
      } else {
        callback();
      }
    };

    return {
      typetrue: false,
      showInDrawer: false,
      formData: {
        companyName: "",
        dutyParagraph: "",
        administratorName: "",
        administratorMobile: "",
        administratorEmail: "",
      },
      title: "",
      type: null,
      btnLoading: false,
      expireDateOptions: {},
      ruleValidate: {
        type: [
          {
            required: true,
            message: "请选择租户类型",
            trigger: "blur",
          },
        ],
        companyName: [
          {
            required: true,
            validator: validateName,
            trigger: "blur",
          },
        ],
        dutyParagraph: [
          {
            required: true,
            validator: validateTax,
            trigger: "blur",
          },
        ],
        administratorName: [
          {
            required: true,
            message: "请填写管理员名称",
            trigger: "blur",
          },
        ],
        administratorMobile: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        administratorEmail: [
          {
            required: true,
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
          {
            type: "email",
            message: "请填写正确的邮箱",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.typetrue = true;

        this.$nextTick(async () => {
          this.$refs["typetrue"].clearSingleSelect();
          let t1 = setTimeout(() => {
            this.typetrue = false;

            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    drwcloseDrawer() {
      this.closeDrawer();
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.$refs.formValidate.resetFields();
        this.cleartRest();
      });
    },
    confirm(name) {
      if (this.type == 0 && this.formData.type == 1) {
        let title = "您确定将租户类型改为客户吗？";
        let content = `<div>将租户类型改为客户后，将不能再改回经销商类型，您确定要更改吗？</div> `;

        // let title = ": " + item.companyName + " ?"
        // if(item.status === 1) title = "您确定要删除该租户吗: <strong style='color:red'>" + item.companyName + " [使用中]</strong> ?"
        this.$Modal.confirm({
          title: title,
          content,
          onOk: () => {
            this.submitForm(name);
          },
          onCancel: () => {},
        });
      } else {
        this.submitForm(name);
      }
    },
    submitForm(name) {
      // if (!this.formData.type)
      //   return this.$Message.info("请选择租户类型");

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.changeDutyParagraph(); // 检测税号
          if (this.formData.id) {
            if (this.formData.openDate)
              this.formData.openDate = moment(this.formData.openDate).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            if (this.formData.expireDate)
              this.formData.expireDate = moment(
                this.formData.expireDate
              ).format("YYYY-MM-DD HH:mm:ss");
          }
          this.btnLoading = true;
          api
            .axss("post", "/ocm-admin/tenant/edit", this.formData)
            .then((res) => {
              if (res.code === "00000") {
                this.$Message.success("提交成功");

                this.drwcloseDrawer(); // 关闭弹窗

                this.getLists(); // 刷新列表
              } else {
                this.$Message.error(res.msg);
              }
              this.btnLoading = false;
            })
            .catch((error) => {
              this.btnLoading = false;
            });
        }
      });
    },
    changeDateOpen(date) {
      this.formData.openDate = date;
      if (!date) this.formData.expireDate = "";
    },
    changeDateExpire(date) {
      this.formData.expireDate = date;
    },
    changeDutyParagraph() {
      // if(this.formData.dutyParagraph.length !== 18) return this.$Message.info('请填写正确的税号')
      const taxNum = this.formData.dutyParagraph;
      if (
        /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/.test(
          taxNum
        ) === false
      )
        return this.$Message.info("请填写正确的税号");
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
  watch: {
    curItemDetail: {
      handler: function (newValue, oldValue) {
        //type
        if (this.$c.isEmptyObject(newValue)) {
          this.title = "新增租户";
          //this.$refs.formValidate.resetFields();
          this.formData = {};
          return;
        } else {
          this.title = "编辑租户";
        }

        if (newValue.type) {
          this.type = newValue.type;
        } else {
          this.type = -1;
        }

        if (newValue !== oldValue) this.$refs.formValidate.resetFields();
        if (newValue.id) {
          this.formData = JSON.parse(JSON.stringify(newValue));
        } else this.formData = {};
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        if (newValue) {
          this.$refs["formValidate"].resetFields();
        }
        this.showInDrawer = newValue;
      },
      deep: true,
    },
    "formData.openDate": {
      handler: function (newValue, oldValue) {
        this.expireDateOptions = {
          disabledDate(date) {
            date = moment(date).format("YYYY-MM-DD HH:mm:ss");
            if (newValue) {
              return date && date.valueOf() < newValue;
            }
          },
        };
      },
      immediate: true,
    },
  },
};
</script>

<style lang="less" scoped>
.rhlistDrawer {
}
</style>
<style>
.timer .ivu-btn-primary {
  color: #ffffff !important;
  background-color: #3d6cb1 !important;
  border-color: #3d6cb1 !important;
  padding: 0 7px !important;
}
</style>
